<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">

                    <el-input v-model="formDatas.acrAmount" style="width: 120px;" size="mini" placeholder="劵面金额"
                        clearable></el-input>
                    <el-select v-model="formDatas.specsType" placeholder="请选择规格类型" style="width: 120px;" size="mini"
                        clearable @change="partserch">
                        <el-option label="普通" :value="1"></el-option>
                        <el-option label="烟感" :value="2"></el-option>
                    </el-select>
                    <el-select v-model="formDatas.billShareType" placeholder="请选择分账类型" style="width: 120px;" size="mini"
                        clearable @change="partserch">
                        <el-option label="折扣67%" :value="1"></el-option>
                        <el-option label="折扣77%" :value="2"></el-option>
                    </el-select>
                    <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <el-button type="success" size="mini" style="margin-right: 20px" @click="BoxOpen">新增券码规格</el-button>
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="specsId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增/编辑 -->
            <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑券码规格' : '新增券码规格'" :before-close="handleClose"
                :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                            <el-form-item label="劵面金额" prop="acrAmount">
                                <el-input v-model="form.acrAmount" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="规格类型" prop="specsType">
                                <el-select v-model="form.specsType" placeholder="请选择" style="width: 80%;">
                                    <el-option label="普通" :value="1"></el-option>
                                    <el-option label="烟感" :value="2"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="分账类型" prop="billShareType">
                                <el-select v-model="form.billShareType" placeholder="请选择" style="width: 80%;">
                                    <el-option label="折扣67%" :value="1"></el-option>
                                    <el-option label="折扣77%" :value="2"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="备注" prop="specsRemark">
                                <el-input v-model="form.specsRemark" style="width: 80%;" type="textarea" :rows="3"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-drawer>
        </div>
    </div>
</template>

<script>
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import { getAjefCertificateRecordSpecsList, addAjefCertificateRecordSpecs, updateAjefCertificateRecordSpecs, deleteAjefCertificateRecordSpecs } from "../../api/api";
export default {
    name: "CertificateRecordSpecs",
    components: {},
    data() {
        return {
            dialog: false,
            edit: false,
            form: {},
            rules: {},
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                selectedRowKeys: [],
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,

            columns: [
                {
                    field: "",
                    key: "checkbox",
                    type: "checkbox",
                    fixed: 'left',
                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "acrAmount",
                    key: "acrAmount",
                    title: "劵面金额",
                    align: "center",
                },
                {
                    field: "specsType",
                    key: "specsType",
                    title: "规格类型",
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        if (row.specsType == 1) {
                            return '普通'
                        } else if (row.specsType == 2) {
                            return '烟感'
                        } else {
                            return ''
                        }
                    },
                },
                {
                    field: "billShareType",
                    key: "billShareType",
                    title: "分账类型",
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        if (row.billShareType == 1) {
                            return '折扣67%'
                        } else if (row.billShareType == 2) {
                            return '折扣77%'
                        } else {
                            return ''
                        }
                    },
                },
                {
                    field: "specsRemark",
                    key: "specsRemark",
                    title: "备注",
                    align: "center",
                },
                { field: "createTime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 100,
                    align: "center",
                    fixed: "right",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: green"
                                    on-click={() => this.handleEdit(row)}
                                >
                                    编辑
                                </el-button>
                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: red"
                                    on-click={() => this.handleDelete(row)}
                                >
                                    删除
                                </el-button>
                            </span>
                        );
                    },
                },
            ],
            tableData: [],
            post: null,
            formDatas: {
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.getList();
    },
    mounted() { },
    methods: {
        openLoading() {
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    deleteAjefCertificateRecordSpecs({ specsId: row.specsId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });
                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        addAjefCertificateRecordSpecs(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateAjefCertificateRecordSpecs(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;
        },
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
        },
        beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }
            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.specsId = row.specsId
                    updateAjefCertificateRecordSpecs(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
        },
        resetSelectedRowKeys(key) {
            this.checkboxOption.selectedRowKeys = [];
            const selectedRowKeysCollection = this.selectedRowKeysCollection;
            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        changeSelectAll(isSelected, selectedRowKeys, key) {
            this.checkboxOption.selectedRowKeys = selectedRowKeys;
            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {
            const rowKey = row[key];
            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {
            this.formDatas.pageSize = pageSize;
            this.partserch();
        },
        pageNumberChange(pageIndex) {
            this.formDatas.currentPage = pageIndex;
            getAjefCertificateRecordSpecsList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
            });
        },
        partserch() {
            this.formDatas.currentPage = 1;
            getAjefCertificateRecordSpecsList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
            });
        },
        getList() {
            getAjefCertificateRecordSpecsList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>
